import React from "react"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { useCustomerInfo } from "@cirrus/common/CustomerInfo"

import { LoginErrorType } from "../../providers/LoginService"

const KEYCODE_ERROR_ID = "keycode-error-id"

export const LoginWithKeycodeErrorHelperText = ({ error }: { error: string }) => {
  const { i18n } = useTranslations()
  const { data } = useCustomerInfo()

  const errorMessageI18nKeys: Record<LoginErrorType, string> = {
    invalid_client: "Login:NotAllowedIp",
    invalid_grant: data?.keycode?.requireUsername ? "Login:InvalidUsernameOrKeycode" : "Login:InvalidKeycode",
    disabled_client: "Login:DisabledUser",
    invalid_role: "Login:NoRole",
  }

  return <div id={KEYCODE_ERROR_ID}>{i18n(errorMessageI18nKeys[error])}</div>
}
